import {Component, OnInit} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {NotificationsService} from "../../service/notifications.service";
import {Title} from "@angular/platform-browser";
import {RecoverPasswordService} from "../../service/recover-password.service";

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['../../../styles.scss', './forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  form: FormGroup;
  email: AbstractControl;

  loading: boolean = false;
  success = false;

  constructor(private recoverPasswordService: RecoverPasswordService,
              private notificationService: NotificationsService,
              private router: Router,
              private fb: FormBuilder,
              private titleService: Title) {
    this.form = this.fb.group({
      email: ['', Validators.required]
    });
    this.email = this.form.controls.email;
  }

  ngOnInit(): void {
    this.titleService.setTitle('Filings Summary - Password Recovery');
  }

  submit() {
    if (this.form.valid) {
      this.success = false;
      this.loading = true;
      this.recoverPasswordService.recoverPassword(this.email.value).subscribe({
        next: resp => {
          this.success = true;
          this.loading = false;
        }, error: error => {

        }
      })
    }
  }

}


